import { getVariant } from '@chessbut/engine';
import type { TimeControl } from '@chessbut/shared';
import { useEffect, useState } from 'react';
import { ChessBut, variantStyle } from '../components/Brand.tsx';
import { RulesList } from '../components/Rules.tsx';
import { api } from '../lib/api.ts';
import { timeControlLabel } from '../lib/format.ts';
import { Link } from '../lib/router.tsx';
import { client, useOnline } from '../online/client.ts';

interface RoomInfo {
  code: string;
  variant: string;
  timeControl: TimeControl;
  host: string;
}

export function JoinPage({ code }: { code: string }) {
  const [info, setInfo] = useState<RoomInfo | null>(null);
  const [gone, setGone] = useState(false);
  const online = useOnline();
  const [joining, setJoining] = useState(false);
  useEffect(() => {
    api<RoomInfo>(`/api/rooms/${encodeURIComponent(code)}`)
      .then(setInfo)
      .catch(() => setGone(true));
  }, [code]);
  useEffect(() => {
    if (online.error && joining) setJoining(false);
  }, [online.error]);

  if (gone) {
    return (
      <div className="page center">
        <h1>That invite has expired</h1>
        <p className="muted">Ask your friend for a new link, or play someone online.</p>
        <Link to="/" className="btn primary big">
          Play ChessBut
        </Link>
      </div>
    );
  }
  if (!info) return <div className="page loading"><span className="spinner big" /></div>;
  const variant = getVariant(info.variant);
  if (!variant) return null;
  return (
    <div className="page" style={variantStyle(variant)}>
      <section className="today">
        <p className="eyebrow">{info.host} invited you to play</p>
        <ChessBut variant={variant} as="h1" />
        <p className="muted">
          {variant.info.name} · {timeControlLabel(info.timeControl)} · casual
        </p>
        <button
          className="btn primary big block"
          disabled={joining || online.status !== 'online'}
          onClick={() => {
            setJoining(true);
            client.joinRoom(code);
          }}
        >
          {online.status !== 'online' ? 'Connecting…' : joining ? 'Joining…' : 'Join the game'}
        </button>
      </section>
      <section className="card">
        <h2 className="section-title">Quick rules</h2>
        <RulesList variant={variant} />
      </section>
    </div>
  );
}
